// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_3hkpz","side":"side_KWI8r","themeLight":"themeLight_2K0fN","themeDark":"themeDark_8cOHI"};